var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.875 12.9375C3.355 12.9375 0.875 7.14683 0.875 4.9375C0.875 3.87663 1.29643 2.85922 2.04657 2.10907C2.79672 1.35893 3.81413 0.9375 4.875 0.9375C5.93587 0.9375 6.95328 1.35893 7.70343 2.10907C8.45357 2.85922 8.875 3.87663 8.875 4.9375C8.875 7.14683 6.395 12.9375 4.875 12.9375ZM4.875 6.9375C5.12994 6.9375 5.38238 6.88729 5.61792 6.78973C5.85345 6.69216 6.06746 6.54917 6.24773 6.3689C6.428 6.18863 6.571 5.97462 6.66856 5.73908C6.76612 5.50355 6.81633 5.25111 6.81633 4.99617C6.81633 4.74123 6.76612 4.48878 6.66856 4.25325C6.571 4.01772 6.428 3.80371 6.24773 3.62344C6.06746 3.44317 5.85345 3.30017 5.61792 3.20261C5.38238 3.10505 5.12994 3.05483 4.875 3.05483C4.36013 3.05483 3.86634 3.25937 3.50227 3.62344C3.1382 3.98751 2.93367 4.48129 2.93367 4.99617C2.93367 5.51104 3.1382 6.00483 3.50227 6.3689C3.86634 6.73297 4.36013 6.9375 4.875 6.9375Z",
    fill: "#42526E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.7108899a.svg";
export { ForwardRef as ReactComponent };